import {react2panel} from 'common/util/react2panel';

import {RetentionCurveChartReact} from './index';

export const RetentionCurveChartEl = react2panel(`mp-retention-curve-chart`, RetentionCurveChartReact, {
  contexts: [`segmentFilterController`],
  wrapperStyles: {
    height: `100%`,
  },
});
